export const LAYER_TYPE = 'rampMeter';

export enum StatusLayerIds {
  METER_PRIMARY_LANE_STATUS_LAYER_ID = 'METER_PRIMARY_LANE_STATUS',
  METER_COMMUNICATION_STATUS_LAYER_ID = 'METER_COMMUNICATION_STATUS',
  METER_TIME_SYNC_STATUS_LAYER_ID = 'METER_TIME_SYNC',
  METER_ACTION_STATUS_LAYER_ID = 'METER_ACTION_STATUS',
  METER_COMMAND_SOURCE_STATUS_LAYER_ID = 'METER_COMMAND_SOURCE_STATUS',
  METER_ALARM_STATUS_LAYER_ID = 'METER_ALARM_STATUS',
  METER_DETAIL_STATUS_LAYER_ID = 'METER_DETAIL_STATUS',
  METER_CROSSHAIR_STATUS_LAYER_ID = 'METER_CROSSHAIR_STATUS',
}

export const RampMeterStatusLayers = [
  StatusLayerIds.METER_PRIMARY_LANE_STATUS_LAYER_ID,
  StatusLayerIds.METER_COMMUNICATION_STATUS_LAYER_ID,
  StatusLayerIds.METER_TIME_SYNC_STATUS_LAYER_ID,
  StatusLayerIds.METER_ACTION_STATUS_LAYER_ID,
  StatusLayerIds.METER_COMMAND_SOURCE_STATUS_LAYER_ID,
  StatusLayerIds.METER_ALARM_STATUS_LAYER_ID,
];
